module.exports = __webpack_public_path__ + "img/clothing158.3dbdbd53.jpg";